import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.TwitterEngagementView extends Monitoring.Reports.Executive.AbstractSectionView
  id: 'twitter_followers'
  name: 'tw-followers-table'
  tagName: 'section'
  template: JST["backbone/templates/monitoring/reports/executive/generic_template"]
  chartClass: 'twitter-followers-table'


  render: ->
    @columns = [ "Cuenta", "#publicaciones", "#rt", "#Respuestas", "Total interacciones", "Engagement rate anual" ]
    @specific_settings ||= {}

    @specific_settings.benchmark = true
    @$el.html(@template(self: this))
    @bindChartsReady(1)
    @_getTable().addClass('processing')
    query = @labelsQuery(@labelFilter(), @labelsStructure())
    client_tw = @options.settings.accountLabel.twitter_account
    rowColorOption = @getTemplateOptions().rows

    @setBenchmarkSettingsIfNecessary(query)
    $.post(@options.chartApi.twitter_engagement, _.extend(query, @getExtraQuery()), (response) =>
      tableData = { columns: @columns, data: [], types: ['string', 'number', 'number', 'number', 'number', 'string'], options: {} }
      if client_tw
        tableData['options'] = { account_description: client_tw, rows: rowColorOption }
      for social_account in response
        tableData.data.push([social_account["name"], social_account["publications"], social_account["retweets"], social_account["responses"], social_account["interactions"], social_account["egmt_rate"]])
      @_getTable().html(new Monitoring.Reports.Executive.TableView(response: tableData).render().el)
      @chartReady(".#{@chartClass}")
    )
    return this

  _getTable: ->
    @$el.find(".#{@chartClass}")
